import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DialogService } from '../../service/dialog.service';
import { Messages } from '../../messages/messages';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'fd-image-uploader',
    templateUrl: './fd-image-uploader.component.html',
    styleUrls: ['./fd-image-uploader.component.scss'],
    standalone: false
})
export class FdImageUploaderComponent implements OnInit {
  selectedFile: File = null;
  @Input() imageUrl: string | ArrayBuffer | SafeResourceUrl = null;
  @ViewChild('inputFile') fileInput: ElementRef | undefined;
  @Output() onImageSelected = new EventEmitter<File>();
  @Output() onImageDeleted = new EventEmitter<null>();
  constructor(private readonly dialogService: DialogService) { }

  ngOnInit(): void {
  }       
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 10) {
        this.openAlertMaxSizeDialog();
        return;
      }

      const extension = file.name.split('.')[1];
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'tif', 'tiff'];
      if (!allowedExtensions.includes(extension)) {
        this.openInvalidFileDialog();
        return
      }
      
      this.onImageSelected.emit(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageUrl = e.target?.result;
      };
      reader.readAsDataURL(file);
    }
  }

  openAlertMaxSizeDialog() {
    this.dialogService.openDialogWithMessage(Messages.UPLOAD_IMAGE_MAX_SIZE_ERROR.description, () => {
      this.resetFileInput();
    });
  }

  openInvalidFileDialog() {
    this.dialogService.openDialogWithMessage(Messages.UPLOAD_IMAGE_INVALID_EXTENSION_ERROR.description, () => {
      this.resetFileInput();
    });
  }
  
  deleteImage() {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DELETE_IMAGE, () => {
      this.resetFileInput();
      this.onImageDeleted.emit();
    });
  }

  resetFileInput() {
    this.imageUrl = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

}
